import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';
import { Text, TEXT_COLORS, TEXT_VARIANTS } from 'ui/Typography';
import Skipped from './Skipped';

const VideoThumbnail = ({
  skipped,
  isCurrentUser,
  mediaThumbnailSrc,
  questionType,
  skipReason,
  isSeismic,
  automatedAnalysis,
  enableAutomatedAnalysis,
}) => {
  const overlayClass = classNames('VideoThumbnail--overlay d-f ai-c jc-c', {
    'VideoThumbnail--overlayNoThumbnail': questionType === 'audio_recording',
  });

  if (skipped) {
    return <Skipped isCurrentUser={isCurrentUser} skipReason={skipReason} />;
  }

  return (
    <div className="VideoThumbnail">
      {(mediaThumbnailSrc === null || questionType === 'audio_recording') && (
        <div
          className={classNames('VideoThumbnail--no-thumbnail', {
            isSeismic,
          })}
        />
      )}
      {mediaThumbnailSrc !== null && questionType !== 'audio_recording' && (
        <img
          className="VideoThumbnail--image"
          src={mediaThumbnailSrc}
          alt={t('questions.question.video_response.thumbnail')}
        />
      )}
      <div className={overlayClass}>
        <Icon name="play" />
      </div>
      {enableAutomatedAnalysis !== false && automatedAnalysis && (
        <div className="pos-a d-f ai-c top-0 w-100p">
          <div className="ml-8 mr-4 p-4-8 bdrs-bottom bg-secondary">
            <Text
              variant={TEXT_VARIANTS.INSTRUX_SMALL_SEMIBOLD}
              color={TEXT_COLORS.ON_SECONDARY}
            >
              {t('automated_analysis.automated_analysis_overall.title')}
            </Text>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoThumbnail;
